// loopingText.js //
import {isOverflowed, debounce} from '../helpers/helpers.js'
import { pauseWhenOffscreen, prefersReducedMotion } from '../utils/pauseWhenOffscreen.js'
import { gsap } from "gsap";

export default class OverflowScrollLoop {
  constructor(els){
      this.bindAll();

      els = (typeof els !== 'undefined') ?  els : document.querySelectorAll('[data-overflow-scroll="tags"]');
      this.els = document.querySelectorAll('[data-overflow-scroll="tags"]');

      this.timelines = []
      this.overflowedEls = []
      this.offscreenDisconnects = []

      if (!this.els.length) return;
      if (prefersReducedMotion()) return;

      this.cloneItems();
      this.initEvents();
  }
  bindAll() {
      ['handleMouseEnter', 'handleMouseLeave', 'resize'].
      forEach(fn => this[fn] = this[fn].bind(this));
  }  
  // Create clones of the text & append them to container
  cloneItems() {
      // let self = this;
      let key = 0;

      this.els.forEach((item) => {
        const parentSelector = item;
        const innerContent = parentSelector.children[0]

          /* on intial execution, if it's overflowed */
          if (isOverflowed(item)) {
              innerContent.innerHTML += ",&nbsp";
              const clone = item.innerHTML;
              parentSelector.insertAdjacentHTML('beforeend', clone);
              parentSelector.setAttribute('data-overflow-scroll-key', key);
              this.buildTimelines(parentSelector, key);
              this.overflowedEls.push(parentSelector);
              key++
          }

      })

  }

  buildTimelines(el, index) {
      const tl = gsap.timeline( {repeat: -1} );
      const elWidth = el.clientWidth / 2;

      tl.to(el, {
        // x: -elWidth,
        xPercent: -50,
        duration: 6,
        ease: 'none'
      })
      this.timelines.push({
        tl: tl,
        key: index
      });

      this.offscreenDisconnects.push(pauseWhenOffscreen(el, tl));
  }
  killTimelines(reset) {
    let self = this;

    // create a promise, and return true once animation is resolved
    let promise = new Promise(function(resolve, reject) {

      self.timelines.forEach((obj) => {
        gsap
        .to(obj.tl, 1.5, {
          progress: 0,
          onComplete: function() {
            obj.tl.kill(true);
            resolve();
          }
        })
      })

    })

    // once animation is complete, kill that motherfucker.
    Promise.all([promise]).then((clone)=>{
      this.timelines.length = 0;
    });

  }
  handleMouseEnter(event) {
    const text = event.target.closest('[data-overflow-scroll="tags"]');
    if (!text) return;
    const key = text.getAttribute('data-overflow-scroll-key');
    const entry = this.timelines[key];
    if (!entry) return;

    gsap.to(entry.tl, .5, {
      timeScale: 0,
      overwrite: true
    });
  }

  handleMouseLeave(event) {
    const text = event.target.closest('[data-overflow-scroll="tags"]');
    if (!text) return;
    const key = text.getAttribute('data-overflow-scroll-key');
    const entry = this.timelines[key];
    if (!entry) return;

    gsap.delayedCall(.2, () => {
      gsap.to(entry.tl, 1, { timeScale: 1 });
    });
  }

  initEvents() {

    this.overflowedEls.forEach((el) => {
      el.addEventListener("mouseenter", this.handleMouseEnter);
      el.addEventListener("mouseleave", this.handleMouseLeave);
    })

  }
  removeEvents() {

    this.overflowedEls.forEach((el) => {
      el.removeEventListener("mouseenter", this.handleMouseEnter);
      el.removeEventListener("mouseleave", this.handleMouseLeave);
    })

  }

  resize() {
    // this.unmount();
    console.log('resize is complete!');

  }

  destroy() {
    if (this.offscreenDisconnects) {
      this.offscreenDisconnects.forEach(fn => fn && fn())
      this.offscreenDisconnects = []
    }
    this.killTimelines();
    this.removeEvents();
  }

}
